<script setup lang="ts">
	//import { addAPIProvider } from '@iconify/vue'
	const apiBase = useRuntimeConfig().public?.apiBase
	const cmsIcons = useRuntimeConfig().public.cmsIcons

	const { name, svgSrc } = defineProps<{name?: string, svgSrc?: string}>()

	if (!name && !svgSrc)
		throw createError('name or svg-src must specified')

	/*if (cmsIcons && apiBase)
		addAPIProvider('local', {
			resources: [`${apiBase}/rest/cms/iconify`]
		})
	*/
	const iconName = computed<string|undefined>(() => {
		/*if (cmsIcons && apiBase && !name.startsWith('@'))
			return '@local:'+name
		return name*/
		if (name) {
			if (name.split(':').length === 2) {
				const bits: string[] = name.split(':')
				return `i-${bits[0]}-${bits[1]}`
			}
			return name
		}
		return
	})

</script>

<template>
	<GsIconSvgUrl v-if="svgSrc" :url="svgSrc" class="inline-block" />
	<UIcon v-else-if="iconName" :name="iconName" />
</template>
